/*
 * Menu click tracking.
 * Pushes a `menu_click` event to the GTM dataLayer for every link clicked in
 * the header menu (desktop mega menu and mobile drawer). GTM forwards it to GA4.
 *
 * Event fields:
 *   menu_device     desktop | mobile
 *   menu_top        top-level menu item, e.g. "Shop All"
 *   menu_group      column / accordion heading, e.g. "Spotlight" (blank if none)
 *   menu_link_type  top_level | link | image_tile | tile_button
 *   menu_path       "Shop All > Spotlight > Discover Platinum® Reserve"
 *   link_text       visible link text (tile images use the tile's button text)
 *   link_url        destination path, e.g. /pages/platinum-reserve
 *
 * One delegated listener, no per-link markup, so menu edits in the admin are
 * tracked automatically.
 */
(function () {
  if (window.__tpMenuClickTracking) return;
  window.__tpMenuClickTracking = true;

  var DESKTOP_ROOT = '.header-menu';
  var MOBILE_ROOT = '.menu-drawer__navigation, .menu-list--mobile';

  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function pathOf(href) {
    try {
      var url = new URL(href, window.location.origin);
      var path = url.pathname;
      try {
        path = decodeURIComponent(path);
      } catch (e) {}
      return url.origin === window.location.origin ? path + url.search : url.href;
    } catch (e) {
      return href || '';
    }
  }

  function summaryText(details) {
    var summary = details && details.querySelector(':scope > summary');
    if (!summary) return '';
    var label = summary.querySelector('.menu-drawer__menu-item-text');
    return clean((label || summary).textContent);
  }

  function linkType(link) {
    var c = link.className || '';
    if (/alt-menu-layout(-mobile)?__image-link/.test(c)) return 'image_tile';
    if (/alt-menu-layout(-mobile)?__cta-link/.test(c)) return 'tile_button';
    if (/menu-list__link|menu-drawer__menu-item--mainlist|menu-list__item/.test(c)) return 'top_level';
    return 'link';
  }

  function tileText(link) {
    var container = link.closest('.alt-menu-layout__image-container, .alt-menu-layout-mobile__image-container');
    var cta = container && container.querySelector('.alt-menu-layout__cta-link, .alt-menu-layout-mobile__cta-link');
    if (cta) return clean(cta.textContent);
    var img = link.querySelector('img[alt]');
    return img ? clean(img.getAttribute('alt')) : '';
  }

  function describeDesktop(link) {
    var top = '';
    var item = link.closest('.menu-list__list-item');
    var title = item && item.querySelector('.menu-list__link-title');
    if (title) top = clean(title.textContent);

    var group = '';
    var groupEl = link.closest('.alt-menu-layout__group, .mega-menu__column, .tp-lines__group');
    if (groupEl) {
      var heading = groupEl.querySelector('.alt-menu-layout__group-title, .tp-lines__group-title');
      if (heading) group = clean(heading.textContent);
    }
    return { top: top, group: group };
  }

  function describeMobile(link) {
    // Collect accordion headings from the outside in.
    var headings = [];
    var details = link.closest('details');
    while (details) {
      var text = summaryText(details);
      if (text) headings.unshift(text);
      details = details.parentElement && details.parentElement.closest('details');
    }
    return { top: headings[0] || '', group: headings.length > 1 ? headings[headings.length - 1] : '' };
  }

  function onClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href)) return;

    var device = '';
    if (link.closest(DESKTOP_ROOT)) device = 'desktop';
    else if (link.closest(MOBILE_ROOT)) device = 'mobile';
    if (!device) return;

    var where = device === 'desktop' ? describeDesktop(link) : describeMobile(link);
    var type = linkType(link);
    var text = type === 'image_tile' ? tileText(link) : clean(link.textContent);
    if (type === 'top_level' && !where.top) where.top = text;

    var path = [where.top, where.group, type === 'top_level' ? '' : text]
      .filter(function (part, i, parts) {
        return part && parts.indexOf(part) === i;
      })
      .join(' > ');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'menu_click',
      menu_device: device,
      menu_top: where.top,
      menu_group: where.group,
      menu_link_type: type,
      menu_path: path,
      link_text: text,
      link_url: pathOf(link.href || href),
    });
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
})();
